<div class="loyalty-widget">
  <div class="widget-content">
    <div class="widget-text">
      <span class="widget-title">You've unlocked a loyalty reward</span>
      <span class="widget-description">Re-amortize your balance + {{interestRateReduction}}% rate reduction - limited offer</span>
    </div>
    <button mat-button color="primary" (click)="onViewDetails()"><span>VIEW DETAILS</span></button>
  </div>
</div>
